import React, { useState, useEffect, useContext } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Stack,
  TextField,
  FormControlLabel,
  Checkbox,
  Box,
} from "@mui/material";
import { DataContext } from "../../../../context/DataContext";
import { getToken } from "../../../../api/Account";
import {
  getGestoresAsync,
  getGestoresBySucursalAccessAsync,
  getSucursalByUserAsync,
} from "../../../../api/Users";
import { getRuta, simpleMessage } from "../../../../helpers/Helpers";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import moment from "moment/moment";
import { accionPrincipalSx } from "../../../../components/ui/accionPrincipal";
const SelectorCreditsCancelled = () => {
  const [gestorList, setGestorList] = useState([]);
  const [selectedGestor, setSelectedGestor] = useState("t");

  const [sucursalList, setSucursalList] = useState([]);
  const [selectedSucursal, setSelectedSucursal] = useState("t");

  var date = new Date();
  const [fechaDesde, setFechaDesde] = useState(
    new Date(date.getFullYear(), date.getMonth(), 1)
  );
  const [fechaHasta, setFechaHasta] = useState(date);
  const [justNoReNew, setJustNoReNew] = useState(false);

  const { setIsLoading, setIsUnautorized } = useContext(DataContext);
  let ruta = getRuta();
  const token = getToken();

  useEffect(() => {
    getGestores(selectedSucursal);
    getSucursals();
  }, []);

  const verReport = () => {
    if (selectedGestor.length === 0) {
      simpleMessage("Seleccione un gestor", "error");
      return;
    }
    if (!moment(fechaDesde).isValid()) {
      simpleMessage("Seleccione una fecha inicial válida", "error");
      return;
    }
    if (!moment(fechaHasta).isValid()) {
      simpleMessage("Seleccione una fecha final válida", "error");
      return;
    }

    var params = `${selectedSucursal}/${selectedGestor}/${moment(
      fechaDesde
    ).format("YYYY-MM-DD")}/${moment(fechaHasta).format(
      "YYYY-MM-DD"
    )}/${justNoReNew}`;
    window.open(`${ruta}/r-creditscancelled/${params}`);
  };

  const getSucursals = async () => {
    setIsLoading(true);
    const result = await getSucursalByUserAsync(token);
    if (!result.statusResponse) {
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      simpleMessage(result.error, "error");
      return;
    }
    setIsLoading(false);
    setSucursalList(result.data.result);
  };

  const onChangeSucursal = (value) => {
    setSelectedSucursal(value);
    getGestores(value);
  };

  const getGestores = async (sucursal) => {
    setIsLoading(true);
    const result =
      sucursal === "t"
        ? await getGestoresBySucursalAccessAsync(token)
        : await getGestoresAsync(token, sucursal);
    if (!result.statusResponse) {
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      simpleMessage(result.error, "error");
      return;
    }

    setIsLoading(false);
    setGestorList(result.data.result);
  };

  return (
    <div>
      <Box sx={{ width: '100%', maxWidth: 550 }}>
        <Stack spacing={2}>
          <FormControl fullWidth style={{ textAlign: "left" }}>
            <InputLabel id="demo-simple-select-standard-label">
              Sucursal
            </InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              onChange={(e) => onChangeSucursal(e.target.value)}
              value={selectedSucursal}
              label="Sucursal"
            >
              {sucursalList.map((item) => {
                return (
                  <MenuItem key={item.id} value={item.id}>
                    {item.description}
                  </MenuItem>
                );
              })}
              <MenuItem key={"t"} value={"t"}>
                TODAS...
              </MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth style={{ textAlign: "left", marginTop: 20 }}>
            <InputLabel id="demo-simple-select-standard-label">
              Gestores
            </InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              onChange={(e) => setSelectedGestor(e.target.value)}
              value={selectedGestor}
              label="Gestores"
              style={{ textAlign: "left" }}
            >
              <MenuItem value="">
                <em>Seleccione un Gestor</em>
              </MenuItem>
              {gestorList.map((item) => {
                return (
                  <MenuItem key={item.id} value={item.id}>
                    {item.fullName}
                  </MenuItem>
                );
              })}
              <MenuItem value={"t"}>TODOS...</MenuItem>
            </Select>
          </FormControl>

          <Stack spacing={2} direction={"row"}>
            <DesktopDatePicker
              closeOnSelect
              label="Desde"
              inputFormat="DD/MM/YYYY"
              value={fechaDesde}
              onChange={(newValue) => setFechaDesde(newValue)}
              renderInput={(params) => <TextField {...params} />}
            />

            <DesktopDatePicker
              closeOnSelect
              label="Hasta"
              inputFormat="DD/MM/YYYY"
              value={fechaHasta}
              onChange={(newValue) => setFechaHasta(newValue)}
              renderInput={(params) => <TextField {...params} />}
            />
          </Stack>

          <FormControlLabel
            labelPlacement="left"
            style={{ marginLeft: 20 }}
            control={
              <Checkbox
                checked={justNoReNew}
                onChange={() => setJustNoReNew(!justNoReNew)}
              />
            }
            label="No Renovados"
          />

          <Button
            variant="contained"
            startIcon={
              <FontAwesomeIcon icon={faPrint} />
            }
            onClick={() => verReport()}
            sx={accionPrincipalSx}
          >
            Generar Reporte
          </Button>
        </Stack>
      </Box>
    </div>
  );
};

export default SelectorCreditsCancelled;
